<template>
  <router-view/>
</template>

<style lang="scss">
@import '~@/sass/main.scss';
#app {
  font-family: 'Source Sans Pro', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--va-primary);
}

body {
  margin: 0;
  background: var(--va-background);
}
</style>
